import React, { useMemo, useState } from 'react';
import { SCREEN_SIZES } from 'constants/config';
import useWindowSize from 'hooks/useWindowSize';
import cn from 'classnames';
import UniversalRecorder from 'components/shared/UniversalRecorder';

const UniversalRecorderButton = ({
  recordButtonText,
  setRecordingStarted,
  seismicRecordingVideoElementEnabled,
  seismicPracticeRecordingEnabled,
  seismicODPRecordingEnabled,
  saveMedia,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isUVRReady, setIsUVRReady] = useState(false);

  const UVR = useMemo(() => {
    const handleComplete = (storageId, format) => {
      setIsOpen(false);

      if (storageId) {
        saveMedia({
          token: storageId,
          isSeismic: true,
          file_format: format,
        });
      }
    };

    return (
      <UniversalRecorder
        isOpen={isOpen}
        handleComplete={handleComplete}
        handleInitialize={() => {}}
        handleRecordingCancel={() => {}}
        handleRecordingStart={() => setRecordingStarted(true)}
        handleRecordingStop={() => setRecordingStarted(false)}
        onUVRReady={() => setIsUVRReady(true)}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const { width } = useWindowSize();

  if (width < SCREEN_SIZES.SM) {
    return <div />;
  }

  return (
    <>
      <button
        type="button"
        className={cn({
          'uvr-btn ba-videorecorder-chooser-button-0 CustomColor--borderColor':
            !seismicODPRecordingEnabled,
          Button:
            seismicRecordingVideoElementEnabled ||
            seismicPracticeRecordingEnabled,
          'Button--primary mb-12 fz-16': seismicODPRecordingEnabled,
        })}
        onClick={() => setIsOpen(true)}
        disabled={!isUVRReady}
      >
        {recordButtonText}
      </button>
      {UVR}
    </>
  );
};

export default UniversalRecorderButton;
